export default {
  inject: ['load'],
  data() {
    return {
      allVertigoDurationsForOther: [],
      vertigoDuration: null,
    };
  },
  methods: {
    getListOfVertigoDurationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVertigoDurations').then(() => {
        if (this.$store.state.vertigoDurationModule.successFlag) {
          this.allVertigoDurationsForOther =
            this.$store.state.vertigoDurationModule.allVertigoDurations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoDurationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfVertigoDurationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getVertigoDurationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getVertigoDuration', id).then(() => {
        if (this.$store.state.vertigoDurationModule.successFlag) {
          this.vertigoDuration = this.$store.state.vertigoDurationModule.vertigoDuration;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoDurationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getVertigoDurationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.vertigoDurationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
